import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface USPDefinition {
  title: string
  subtitle: string
  imageId: string
}

function useUltraLuxLabels() {
  const intl = useIntl()

  return useMemo(() => ({
    hotels: {
      premium: (_regionCode: string | undefined): USPDefinition => ({
        title: intl.formatMessage({
          id: 'npKMT3pTKxYXkrHKMan2',
          defaultMessage: 'Exceptional 5 & 6 star properties',
          description: 'Ultra lux USP title for exceptional hotel properties',
        }),
        subtitle: intl.formatMessage({
          id: 'oxo85CXAHLEI9fOv1nmf',
          defaultMessage: 'Get access to exclusive luxury hotels around the world',
          description: 'Ultra lux USP subtitle for exceptional hotel properties',
        }),
        imageId: 'tujk1y9ccy97sf0dcrk4',
      }),
      service: (regionCode: string | undefined): USPDefinition => {
        if (regionCode === 'IN') {
          return {
            title: intl.formatMessage({
              id: 'FG3InE6F5-zVo4pTNW2U',
              defaultMessage: 'Premium concierge service',
              description: 'Ultra lux USP title for concierge service in India region',
            }),
            subtitle: intl.formatMessage({
              id: 'ZXhXuEW0HmnkGqG6k4TJ',
              defaultMessage: 'Our team are available anytime, 9am to 7pm, 7 days a week.',
              description: 'Ultra lux USP subtitle for concierge service in India region',
            }),
            imageId: '86zfuzec9prni5yzhzcd',
          }
        }
        return {
          title: intl.formatMessage({
            id: 'CwdSwZcWLYXiUVOUSYy2',
            defaultMessage: '24/7 Premium concierge service',
            description: 'Ultra lux USP title for 24/7 concierge service for computed display labels',
          }),
          subtitle: intl.formatMessage({
            id: '3sHhhnTLqTrBN7bhAPzV',
            defaultMessage: 'Our team are available anytime, 24 hours, 7 days a week',
            description: 'Ultra lux USP subtitle for 24/7 concierge service for computed display labels',
          }),
          imageId: '86zfuzec9prni5yzhzcd',
        }
      },
    },
    tours: {
      premium: (_regionCode: string | undefined): USPDefinition => ({
        title: intl.formatMessage({
          id: 'XuiCxFQnx2CZpRD2Rip-',
          defaultMessage: 'Exceptional tours',
          description: 'Ultra lux USP title for exceptional tours on the tour page',
        }),
        subtitle: intl.formatMessage({
          id: 'ZtGl7CcHBWaoo4B8RwjS',
          defaultMessage: 'Get access to expertly curated tours, coupled with the world’s most prestigious hotels',
          description: 'Ultra lux USP subtitle for exceptional tours on the tour page',
        }),
        imageId: 'b6xj75dk8i9wji8fit5ch',
      }),
      service: (regionCode: string | undefined): USPDefinition => {
        if (regionCode === 'IN') {
          return {
            title: intl.formatMessage({
              id: '4B3WeF9Lg5TpORPLQWVb',
              defaultMessage: 'Premium concierge service',
              description: 'Ultra lux tours USP title for concierge service in India region',
            }),
            subtitle: intl.formatMessage({
              id: 'VW_Zo7TgtUkhkELmPZWf',
              defaultMessage: 'Our team are available anytime, 9am to 7pm, 7 days a week.',
              description: 'Ultra lux tours USP subtitle for concierge service in India region',
            }),
            imageId: '86zfuzec9prni5yzhzcd',
          }
        }
        return {
          title: intl.formatMessage({
            id: 'qHf3pvjU0W2juPYOUptN',
            defaultMessage: '24/7 Premium concierge service',
            description: 'Ultra lux tours USP title for 24/7 concierge service',
          }),
          subtitle: intl.formatMessage({
            id: 'OrSGe3Z9QjFYeKQqtqAx',
            defaultMessage: 'Our team are available anytime, 24 hours, 7 days a week',
            description: 'Ultra lux tours USP subtitle for 24/7 concierge service',
          }),
          imageId: '86zfuzec9prni5yzhzcd',
        }
      },
    },
    cruises: {
      premium: (_regionCode: string | undefined): USPDefinition => ({
        title: intl.formatMessage({
          id: 'qMYa5qYML7MjK0XZZK9L',
          defaultMessage: 'Unforgettable cruises',
          description: 'Ultra lux USP title for unforgettable cruises for computed display labels',
        }),
        subtitle: intl.formatMessage({
          id: 'yL6tL2Oznn7PV18kOz9T',
          defaultMessage: 'Get access to sailings onboard the world’s most luxurious ships with unmatched service',
          description: 'Ultra lux USP subtitle for unforgettable cruises for computed display labels',
        }),
        imageId: 'nm8nh9vh6sys7ifvjnf',
      }),
      service: (regionCode: string | undefined): USPDefinition => {
        if (regionCode === 'IN') {
          return {
            title: intl.formatMessage({
              id: 'WNGTukgyCQnEAfeFvbeV',
              defaultMessage: 'Premium concierge service',
              description: 'Ultra lux cruises USP title for concierge service in India region',
            }),
            subtitle: intl.formatMessage({
              id: 'D2dK2Ofyi49MCMjJYDfV',
              defaultMessage: 'Our team are available anytime, 9am to 7pm, 7 days a week.',
              description: 'Ultra lux cruises USP subtitle for concierge service in India region',
            }),
            imageId: '86zfuzec9prni5yzhzcd',
          }
        }
        return {
          title: intl.formatMessage({
            id: 'p70cBj3j3PrrSpK-XnVU',
            defaultMessage: '24/7 Premium concierge service',
            description: 'Ultra lux cruises USP title for 24/7 concierge service',
          }),
          subtitle: intl.formatMessage({
            id: 'a3mBrrNyErJyEFZXFlu9',
            defaultMessage: 'Our team are available anytime, 24 hours, 7 days a week',
            description: 'Ultra lux cruises USP subtitle for 24/7 concierge service',
          }),
          imageId: '86zfuzec9prni5yzhzcd',
        }
      },
    },
  }), [intl])
}

export default useUltraLuxLabels
